export default __webpack_public_path__ + "static/media/boue.25d02cb5.svg";